// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-detail[data-v-609fcdcc]{display:flex;flex-direction:row;gap:0 .5rem}.text__user-detail[data-v-609fcdcc]{display:flex;flex-direction:column}.text__user-detail>.text__user-name[data-v-609fcdcc]{color:var(--primary);font-weight:600;font-size:1rem}.text__user-detail>.text__user-role[data-v-609fcdcc]{color:var(--dark);font-weight:400;font-size:.75rem;padding-left:2px}.text__date[data-v-609fcdcc]{font-weight:500;font-size:1rem}", ""]);
// Exports
module.exports = exports;
